import './embed.scss';
import { render as vevRender } from './core';
import { IAppState } from 'vev';
import { pageKeyByPath } from './utils/route';
import system from './system';
import { loadCss } from './system/utils';
import polyfills from './core/polyfills';

import * as core from './core';
// Check if vev is already loaded by checking the window vev var
if (!(window as any).vev) {
  // Load browser polyfills then start detection of vev root nodes
  polyfills().then(() => {
    // Listen for animation start to detect vevroot elements (animationstart is triggered even if the element was added before script was loaded)
    document.addEventListener('animationstart', onVevRootDetect, false);

    // Adding style animation to vevroot
    const style = document.createElement('style');
    style.innerHTML = `@keyframes vevroot{from{ opacity: 0.99}to{ opacity: 1}}vevroot{animation-duration: 0.001s;animation-name: vevroot}`;

    document.head.appendChild(style);
  });

  (window as any).vev = { ...core, render, init };
} else console.warn('Multiple vev scripts loaded');

const vevNodes: HTMLElement[] = [];
const states: { [projectKey: string]: IAppState } = {};
const projectPromises: { [key: string]: Promise<void> } = {};

function init(node: HTMLElement) {
  if (vevNodes.indexOf(node) !== -1) return;

  let [domain, project, path] = (node.dataset.path || '').replace(/^https?:\/\//, '').split('/');

  if (domain !== 'hook' && domain.split('.').length === 1) {
    path = project;
    project = domain;
    domain = 'eit.vev.design';
  }
  node.dataset.project = project;
  node.dataset.path = path || '';
  vevNodes.push(node);
  // IF state for project exists, then content was loaded before init happened
  // Else if hot a hook, then load the embed project
  if (states[project]) doRender(node, states[project]);
  else if (domain !== 'hook') load(domain, project);
}

/**
 * `load` loads the embed scripts and css related to the given project
 */
function load(domain: string, projectKey: string): Promise<void> {
  // If not already loading the embed file then start loading the embed file
  if (!projectPromises[projectKey]) {
    projectPromises[projectKey] = fetch(`https://${domain}/${projectKey}/embed.json`)
      .then((r) => r.json())
      .then((r: { css: string[]; js: string[] }) => {
        r.js.filter((u) => !/vev.js$/.test(u)).forEach(system.fetch);
        r.css.forEach((u) => loadCss(u.replace('vev.css', 'embed.css')));
      });
  }
  return projectPromises[projectKey];
}

/**
 * `render`triggered when the project content is loaded.
 * This will render to all detected nodes with the given project
 * Stores away the app state in case node is added later
 */
function render(state: IAppState) {
  states[state.project] = state;
  for (const node of vevNodes) {
    if (node.dataset.project === state.project) doRender(node, state);
  }
}

function doRender(node: HTMLElement, state: IAppState) {
  if (node.dataset.r) return;
  node.dataset.r = 'true';
  vevRender(
    {
      ...state,
      embed: true,
      route: { pageKey: pageKeyByPath(node.dataset.path, state.pages, state.dir) }
    },
    node,
    true
  );
}

function onVevRootDetect(e: AnimationEvent) {
  if (e.animationName == 'vevroot') init(e.target as HTMLElement);
}
